import { createRoutine } from 'redux-saga-routines'

export const CONTENT = createRoutine('PAGES/CONTENT')
